import { Middleware } from 'redux';
import { FicheAutocontroleActionTypes } from '../types/FicheAutocontrole.Types';
import { OfflineCache } from '../../utils/OfflineCache';
import ProgressBarService from '../../utils/progressBar.service';

export const offlineMiddleware: Middleware = store => {
  let saveTimeout: NodeJS.Timeout | undefined;
  return next => action => {
    const result = next(action);

    if (action.type === FicheAutocontroleActionTypes.FETCH_DATA) {
      clearTimeout(saveTimeout);
    }

    if (action.type === FicheAutocontroleActionTypes.LOCATION_CHANGE) {
      OfflineCache.clear();
    }

    if (action.type === FicheAutocontroleActionTypes.UPDATE_TAB ||
        action.type === FicheAutocontroleActionTypes.UPDATE_TAB_INFOS ||
        action.type === FicheAutocontroleActionTypes.UPDATE_TAB_RESERVES) {
      
      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(() => {
        const state = store.getState();
        const data = state.ficheAutocontrole?.data;
        if (data && action.payload) {
          OfflineCache.save(
            action.payload,
            ProgressBarService.getComplitionPercent(data),
            data.statut
          );
        }
      }, 5000);
    }

    return result;
  };
};
